import { render, staticRenderFns } from "./DigitalCouponsRoute.vue?vue&type=template&id=39e0ff32&scoped=true&"
import script from "./DigitalCouponsRoute.vue?vue&type=script&lang=js&"
export * from "./DigitalCouponsRoute.vue?vue&type=script&lang=js&"
import style0 from "./DigitalCouponsRoute.vue?vue&type=style&index=0&id=39e0ff32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e0ff32",
  null
  
)

export default component.exports